import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AccountHeader from './AccountHeader';
import '../static/css/SettingsPage.css';
import '../static/css/Rules.css';

class Rules extends Component {
    render() {
        return (
            <div className="settings-page">
                <AccountHeader />
                <div className="settings-page-content rules-content">
                    <Link to="/home" className="settings-back-link">Back</Link>
                    <h2 className="settings-page-title color-1" style={{fontFamily: "'Chelsea Market', cursive"}}><u>Rules</u></h2>

                    <div className="rules-card">
                        <p className="rules-intro">
                            AniMates is a community for anime fans to connect, host meetups, make friends, and share their love of anime in real life. <span className="rules-intro-motto">Your anime world, IRL.</span> To keep this space safe, fun, and welcoming, every member agrees to follow these rules. Breaking them can lead to warnings, content removal, suspension, or a permanent ban.
                        </p>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Be Authentic</h3>
                            <ul className="rules-list">
                                <li>Use your real first name and clear, recent photos that actually look like you.</li>
                                <li>One profile per person — no impersonation, no fake accounts, no catfishing.</li>
                                <li>Don't post photos that aren't yours or that you don't have permission to use.</li>
                            </ul>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Be Respectful</h3>
                            <p className="rules-paragraph">
                                Treat every member with kindness — no matter their background, taste in anime, or experience level. Disagreements happen; handle them with grace. Personal attacks, harassment, intimidation, stalking, and unwanted advances are not tolerated.
                            </p>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>No Hate Speech</h3>
                            <p className="rules-paragraph">
                                Discrimination, slurs, or hateful content targeting anyone based on race, ethnicity, national origin, religion, gender, gender identity, sexual orientation, disability, age, or any other protected trait will result in immediate removal from the platform.
                            </p>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>You Must Be 18 or Older</h3>
                            <p className="rules-paragraph">
                                AniMates is for adults. You must be at least 18 years old to create an account or attend a meetup organized through the platform. Accounts found to belong to minors will be removed.
                            </p>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Safety When Meeting in Person</h3>
                            <p className="rules-paragraph">
                                Meeting people from the internet is exciting — please do it carefully.
                            </p>
                            <ul className="rules-list">
                                <li>Meet in public, well-lit places like coffee shops, restaurants, or conventions, especially for first meetups.</li>
                                <li>Avoid meeting at night unless you already know and trust the person.</li>
                                <li>Tell a friend or family member where you're going and who you're meeting.</li>
                                <li>Trust your instincts. If something feels off, leave.</li>
                                <li>We encourage public group meetups over one-on-one until you've built trust.</li>
                                <li>Arrange your own transportation to and from the meetup.</li>
                            </ul>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Keep Conversations on AniMates</h3>
                            <ul className="rules-list">
                                <li>Don't share personal information — full home address, phone number, full legal name — with people you don't know well.</li>
                                <li><strong className="rules-strong">Never share credit card numbers, bank info, passwords, or financial details.</strong> AniMates and GS Studios LLC will never ask for these.</li>
                                <li>Be cautious if someone tries to move your conversation off-platform too quickly.</li>
                                <li>If anyone asks for money, gifts, cryptocurrency, or financial favors, report them right away — these are common scam patterns.</li>
                            </ul>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Event Conduct</h3>
                            <ul className="rules-list">
                                <li>Show up if you RSVP — or cancel in advance so the host knows.</li>
                                <li>Respect the host's plan, rules, and chosen venue.</li>
                                <li>Don't use AniMates events to sell products, recruit, or promote services without host approval.</li>
                                <li>Be inclusive — welcome new attendees, don't form cliques.</li>
                                <li>Respect attendees' boundaries, including around photography and social media tagging.</li>
                            </ul>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>No Illegal or Harmful Activity</h3>
                            <ul className="rules-list">
                                <li>No promotion or facilitation of illegal activity, including drugs, weapons, or violence.</li>
                                <li>No threats of violence, self-harm, or harm to others.</li>
                                <li>No content that promotes terrorism, organized hate groups, or human trafficking.</li>
                                <li>No commercial sex work, escort services, or solicitation.</li>
                                <li>Follow all applicable laws, both online and at meetups.</li>
                            </ul>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>No Explicit or Inappropriate Content</h3>
                            <ul className="rules-list">
                                <li>No nudity, sexually explicit photos, or graphic content in profiles, messages, or events.</li>
                                <li>Absolutely no content that sexualizes minors. This is a zero-tolerance rule and will be reported to the appropriate authorities.</li>
                                <li>No graphic violence, gore, or content designed to shock or disturb.</li>
                                <li>Keep cosplay and event content tasteful and appropriate for a general audience.</li>
                            </ul>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Privacy & Consent</h3>
                            <ul className="rules-list">
                                <li>Get consent before sharing photos or videos of other AniMates members, especially from meetups.</li>
                                <li>Don't share private conversations, screenshots, or personal details from members without their permission.</li>
                                <li>Respect when someone asks not to be photographed, tagged, or contacted again.</li>
                            </ul>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Reporting</h3>
                            <ul className="rules-list">
                                <li>If a member or event violates these rules, report it in-app.</li>
                                <li>You can also block users to remove them from your experience.</li>
                                <li>We review every report and take action where warranted.</li>
                                <li>For urgent safety issues or law-enforcement matters, contact local authorities first, then email us at <a href="mailto:hello@animates.app" className="rules-link">hello@animates.app</a>.</li>
                            </ul>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Enforcement & Updates</h3>
                            <ul className="rules-list">
                                <li>GS Studios LLC, dba AniMates, may warn, suspend, restrict, or permanently remove any account that violates these rules, with or without notice.</li>
                                <li>We may also remove content, cancel events, or block messages that violate these rules.</li>
                                <li>These rules may be updated from time to time. Continued use of AniMates after changes means you accept the updated rules.</li>
                            </ul>
                        </section>

                        <section className="rules-section">
                            <h3 className="rules-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Our Role</h3>
                            <p className="rules-paragraph">
                                AniMates is a platform operated by <strong className="rules-strong">GS Studios LLC, doing business as AniMates</strong>. We provide tools to help anime fans connect and organize meetups; we are not a chaperone, escort, or guarantor of any user's behavior or identity.
                            </p>
                            <p className="rules-paragraph">
                                By using AniMates, you acknowledge that you are responsible for your own safety, decisions, and interactions both online and in person. To the fullest extent permitted by law, GS Studios LLC and AniMates are not liable for incidents, disputes, injuries, losses, or damages that occur at meetups, in private conversations, or as a result of connections made through the platform.
                            </p>
                            <p className="rules-paragraph">
                                We're here to help spread positivity — please help us keep this community safe for everyone.
                            </p>
                        </section>

                        <p className="rules-footer-note">
                            Questions about these rules? Email <a href="mailto:hello@animates.app" className="rules-link">hello@animates.app</a>.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Rules;
